import { useContext, useEffect } from "react";
import { View } from "tamagui";

import { LayoutContext } from "@/components/LayoutProvider";
import Orders from "@/components/Orders";

export default function FilesLayout() {
  const { headerHeight, setShowHeader } = useContext(LayoutContext);

  useEffect(() => {
    setShowHeader(false);
    return () => {
      setShowHeader(true);
    };
  }, [setShowHeader]);

  return (
    <View
      backgroundColor="$backgroundFill"
      height="100%"
      width="100%"
      alignItems="stretch"
      justifyContent="flex-start"
      flex={1}
      borderRadius="$screenBorderRadius"
      paddingTop={headerHeight.current + 40}
      $lg={{ paddingTop: headerHeight.current }}
    >
      <Orders />
    </View>
  );
}
